// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { FORM_TO_DF_MAPPING } from '../mxProperties';

// this is taken from
// https://github.com/eka-care/pocket/blob/93d36725b77268890d8cde9ae5a4a1a0a026bd7b/src/external/medpay/medpay-helper.ts

const durationEnum = {
    days: 1,
    weeks: 7,
    months: 30,
    years: 365,
    hours: 1 / 24,
    day: 1,
    week: 7,
    month: 30,
    year: 365,
    hour: 1 / 24,
};

export function calculateQuantity(frequency = {}, duration = {}, dose = {}): string {
    if (!duration) {
        duration = {};
    }

    if (!dose) {
        dose = {};
    }

    if (!frequency) {
        frequency = {};
    }

    const { custom: cFreq = '', value: vFreq = '' } = frequency;
    const { custom: cDur = '', value: vDur = '', unit: uDur = '' } = duration;
    const { custom: cDose = '', value: vDose = '', unit = '' } = dose;

    const aFreq = vFreq ? vFreq : cFreq;
    const aDur = vDur && uDur ? vDur + ' ' + uDur : cDur;
    const aDose = vDose ? vDose : cDose;

    let fq = dailyFreq(aFreq);
    const dur = computeDuration(aDur);
    const rDose = computeDose(aDose);

    // if dose is custom => unit and rdose will be returned
    const runit = computeUnit(unit, cDose);

    // check if freq has `once every ...`
    const onceEveryFq = stringFreq(aFreq);

    if (onceEveryFq != null) {
        fq = onceEveryFq;
    }

    // console.log({ fq, dur, rDose });
    // Freq X Days X Unit
    // return Z units

    let fValue = fq * dur * rDose;

    fValue = Math.ceil(parseFloat(fValue, 10));

    if (Number.isNaN(fValue)) {
        // this os different from pocket, because pocket use case is for ordering medicine, which by default is 1, but in our case it is 0 (no quantity)
        fValue = 0;
    }

    return fValue > 0 ? fValue.toString() + ' ' + runit : '';
}

const mxDyForms = Object.keys(FORM_TO_DF_MAPPING);

function computeUnit(unit = '', cDose = '') {
    if (unit) {
        return unit;
    }

    if (!cDose) {
        return 'unit';
    }

    // if aDose exists
    // see if cDose was custom => ` 1 tablet `

    let runit = 'unit';

    for (let i = 0; i < mxDyForms.length; i++) {
        const thisForm = mxDyForms[i];

        const textDose = cDose.toLowerCase();

        if (textDose.indexOf(thisForm) !== -1) {
            // this form matched
            runit = thisForm;
            break;
        }
    }

    return runit;
}

function computeDose(doseValue) {
    try {
        if (typeof doseValue === 'string') {
            const clean = doseValue.trim().replace(/\s+/g, '');
            if (clean === '') return 1;
            if (clean.includes('/')) {
                const [num, denom] = clean.split('/').map(Number);
                if (!isNaN(num) && !isNaN(denom) && denom !== 0) {
                    return num / denom;
                }
            }

            const parsed = Number(clean);
            if (!isNaN(parsed)) return parsed;
        }

        if (typeof doseValue === 'number' && !isNaN(doseValue)) {
            return doseValue;
        }
        return 1;
    } catch (err) {
        console.log('Error in computing - dose');
        return 1;
    }

    return 1;
}

function computeDuration(durString = '1') {
    // lowercase
    const aDur = durString.toLocaleLowerCase();

    // check if has 2 values

    const durArray = aDur.split(' ');

    const val = durArray[0] || 1;
    const unit = durArray[1] || 'day';

    if (val || unit) {
        // value + unit
        // parse unit and multiply
        // return

        let u = 1; // unit
        let v = 1; // value

        try {
            v = parseInt(val, 10);
            if (Number.isNaN(v)) {
                v = 1;
            }
        } catch (err) {
            console.log(err);
            console.log('unit computeDuration broke');
            v = 1;
        }

        try {
            u = durationEnum[unit];
            if (!u) {
                u = 1;
            }
        } catch (err) {
            console.log(err);
            console.log('unit computeDuration broke');
            u = 1;
        }

        return v * u;
    }

    // this os different from pocket, because pocket use case is for ordering medicine, which by default is 1, but in our case it is 0 (no duration)
    return 0;
}

function dailyFreq(freqString = '') {
    const fqArr = freqString.split('-').map((i) => i.trim());

    if (!fqArr.length) {
        // this os different from pocket, because pocket use case is for ordering medicine, which by default is 1, but in our case it is 0
        return 0;
    }

    let fqInt = 0;

    fqArr.forEach((fq) => {
        try {
            fqInt += eval(fq);
        } catch (e) {
            console.log(e);
            console.log('Error in dailyFreq, ignoring: ' + fq);
        }
    });

    if (Number.isNaN(fqInt) || fqInt === 0) {
        // this os different from pocket, because pocket use case is for ordering medicine, which by default is 1, but in our case it is 0 (no frequnecy)
        return 0;
    }

    return fqInt;
}

function stringFreq(freqString = '') {
    // is once every?
    freqString = freqString?.toLowerCase();
    if (freqString?.startsWith('once a ')) {
        freqString = freqString?.replace('once a ', 'once every 1 ');
    } else if (freqString?.startsWith('once an ')) {
        freqString = freqString?.replace('once an ', 'once every 1 ');
    }

    if (freqString.indexOf('once every') == -1) {
        return null;
    }

    // parse the last 2 string

    const fqArr = freqString.split(' ');
    const len = fqArr.length;
    if (len !== 4) {
        return null;
    }

    // output = 1 week or 2 weeks ...
    const dayTimeString = fqArr.slice(fqArr.length - 2, fqArr.length).join(' ');

    // 14 days or 7 days ...
    const onceEveryDays = computeDuration(dayTimeString);

    // 1/7 = 0.14 || 1/14 = 0.07 ...
    const perDayFloat = 1 / onceEveryDays;

    // const perDayvalue = Math.ceil(perDayFloat)

    // return

    return perDayFloat;
}

export const FREQUENCY_TO_TEXT_VALUE: {
    [k: number]: string;
} = {
    1: 'once every 1 day',
    2: 'once every 12 hours',
    3: 'once every 8 hours',
    4: 'once every 6 hours',
    6: 'once every 4 hours',
    8: 'once every 3 hours',
    12: 'once every 2 hours',
    24: 'once every 1 hour',
};
